(ns dashboard.views.policy.subs
  (:require [re-frame.core :as rf]))

(rf/reg-sub
 ::policy-status
 (fn [db [_ document-id]]
   (get-in db [:page :policies :item-statuses document-id])))
